import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';

var Config = require('../../../config');
var socket = "";

class LabelModal extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.onChangePlantilla = this.onChangePlantilla.bind(this);
		this.printingLabel = this.printingLabel.bind(this);
		this.directPrint = this.directPrint.bind(this);
		this.openPDF = this.openPDF.bind(this);

		this.state = {
			show: false,
			options:[],
			preview_print:{},
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		socket= this.props.socket !== undefined && this.props.socket !== "" ? this.props.socket : new WebSocket("wss://localhost:2018");

		socket.onerror = (event)=> {
			console.log(event);
		};

		socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	directPrint(response, label_type){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = function() {
		  var base64data = reader.result;  
		  var aux = base64data.split(',');
		  socket.send('{"Operacion":"print", "Type":"'+label_type+'", "File": "'+aux[1]+'"}');
		}
	}

	handleShow(donation){
		var url = '';

		if(donation.extraction_type === null || donation.extraction_type === undefined){
			url = 'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+
					'&file_type=label_extraction&extraction_type=';
		}else{
			this.setState({
				type_extraction_name: donation.extraction_lookup
			});

			url = 'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+
					'&file_type=label_extraction&extraction_type='+donation.extraction_type;
		}

		fetch(Config.default.apiGateway.URL+url,{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
              });
            }})
		.then(response => {

			if(response.res === 0){
				swal('Error', 'No existen formatos definidos para este tipo de impresión.', 'error');
			}else{
				
				this.setState({
					show: true,
					number_templates:response.res,
					register_id:donation.donation_id,
					template_number:[],
					options:[],
					opening:false,
					label_type: 'label_extraction'
				})
			
				var opt = []

				for(var i = 0; i <= parseInt(response.res,10); i++){	
					if(i === 0){
						opt.push({value:i, check:false});
					}else{
						opt.push({value:i-1, check:false});
					}			
				}
				this.setState({
					options: opt
				});
				
					
			}
		})
	}

	handleClose(){
		this.setState({show:false});
	}

	openPDF(){
		const select = document.querySelector('div.modal-body');
		const ctrls = select.querySelectorAll('input');
		var etiqueta = []

		if(ctrls[0].checked){
			etiqueta.push(parseInt(ctrls[0].value));
		}else{
			ctrls.forEach(function(ctrl, i){
				if(ctrl.checked){
					etiqueta.push(parseInt(ctrl.value));
				}
			})
		}
		

		this.printingLabel(etiqueta);
	}

	printingLabel(etiqueta){
		var obj ={};
		obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
		obj.id = this.state.register_id.toString(); //donation_id
		obj.file_type = this.state.label_type; //label_extraction
		obj.nEtiqueta = etiqueta;
		obj.name = this.state.type_extraction_name;// == "SANGE TOTAL"?"SANGRE_TOTAL":"AFÉRESIS";

		this.props.waiting.handleShow('Imprimiendo...');
		fetch(Config.default.apiGateway.URL+"labelsEditor", {
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
                return;
              });
            }
		})
		.then(response => {
			if(response !== undefined){
				if(this.state.preview_print.value ==="NO"){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					this.directPrint(response, this.state.label_type);
				}
				
	       		this.setState({ show: false});
       		}
		})
	}

	onChangePlantilla(e){

		var options = this.state.options;

		const select = document.querySelector('div.modal-body');
		const ctrls = select.querySelectorAll('input');

		ctrls.forEach(function(ctrl, i){
			if(ctrls[0].name == e.target.name){
				if(ctrls[0].checked){
					options[i].check = true;
				}else{
					options[i].check = false;
				}				
			}else{
				if(ctrl.name === e.target.name){
					if(ctrl.checked){
						options[i].check = true;

						var check = 1;
						options.map(function(opt, j){
							if(j > 0 && opt.check)
								check++;
						})

						if(check === options.length)
							options[0].check = true;

					}else{
						if(ctrls[0].checked){
							options[0].check = false;
							options[i].check = false;
						}else{
							options[i].check = false;
						}
					}
				}
			}
		})

		this.setState({
			options: options
		})
	}

	render(){
		const {t} = this.props;

		return (
			<Modal show={this.state.show} onHide={this.handleClose} >
		       	<Modal.Header closeButton>
		        	<Modal.Title>Etiquetas</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{padding:"0px 20px 0px 20px"}}>
				        <div className="col-xs-12 col-sm-5 col-sm-offset-4" >
							<Table responsive hover>
								<thead>
									<tr>
										<th></th>
										<th>Plantillas</th>
									</tr>
								</thead>
								<tbody>
									
									{this.state.options.lenght !== 0 ?
										this.state.options.map((option, i)=>(
											<tr key={i}>
											
												<td>
													<input type="checkbox" value={option.value} name={'o'+i} id={'o'+i} 
													 onChange={this.onChangePlantilla} checked={option.check}/>
												</td>
												<td>{i === 0 ? 'Todos' : i}</td>
										
											</tr>
										))
									: null
									}
									
								</tbody>
							</Table>
						</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.print')}  onClick={this.openPDF}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}
}

export default translate('translations')(LabelModal)